'use client';

import * as React from 'react';
import { format } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { DateRange } from 'react-day-picker';

import { cn } from '#/lib/utils';
import { Button } from '#/components/ui/button';
import { Calendar } from '#/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '#/components/ui/popover';
import { FORMAT_DATE, LOCALE_KO } from '#/lib/date';
import { useEffect } from 'react';

interface DatePickerWithRangeProps {
  className?: string;
  title?: string;
  from?: Date;
  to?: Date;
  onSelect: (range?: DateRange) => void;
  footer?: React.ReactNode;
}

export function DatePickerWithRange({
  className,
  onSelect,
  title = '날짜를 선택하세요.',
  from,
  to,
  footer
}: DatePickerWithRangeProps) {
  const [date, setDate] = React.useState<DateRange | undefined>({
    from,
    to
  });

  useEffect(() => {
    setDate({ from, to });
  }, [from, to]);

  return (
    <div className={'grid gap-2'}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant={'outline'}
            className={cn(
              'w-[300px] justify-start text-left font-normal',
              !date && 'text-muted-foreground',
              className
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, FORMAT_DATE)} ~{' '}
                  {format(date.to, FORMAT_DATE)}
                </>
              ) : (
                format(date.from, FORMAT_DATE)
              )
            ) : (
              <span>{title}</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="range"
            locale={LOCALE_KO}
            defaultMonth={date?.from}
            selected={date}
            onSelect={(range) => {
              setDate(range);
              if (range && range.from && range.to) {
                onSelect(range);
              }
            }}
            numberOfMonths={2}
          />
          {footer && <div className="p-6">{footer}</div>}
        </PopoverContent>
      </Popover>
    </div>
  );
}
